{
  "version": 1,
  "asset_id": "f39775b3-1bb7-482f-a529-56984a28d674",
  "project_id": "e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811",
  "url": "/__l5e/assets-v1/f39775b3-1bb7-482f-a529-56984a28d674/clip-img_2160.mp4",
  "r2_key": "a/v1/e1a64cc6-0fc8-4a5b-9036-8fa01cc3f811/f39775b3-1bb7-482f-a529-56984a28d674/clip-img_2160.mp4",
  "original_filename": "clip-img_2160.mp4",
  "size": 302115,
  "content_type": "video/mp4",
  "created_at": "2026-08-01T22:32:50Z"
}
